import { render } from "./ViewService.vue?vue&type=template&id=2a5121a4&ts=true"
import script from "./ViewService.vue?vue&type=script&lang=ts"
export * from "./ViewService.vue?vue&type=script&lang=ts"

import "./ViewService.vue?vue&type=style&index=0&id=2a5121a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__